import ServiceActiveIcons from '@/icons/ServiceActiveIcons'
import ServiceTrialIcons from '@/icons/ServiceTrialIcons'
import ServiceWaitingConfirmIcons from '@/icons/ServiceWaitingConfirmIcons'
import AllService from './AllService'
import POC from './POC'
import WaitingConfirm from './WaitingConfirm'
import DeviceLiquidation from './DeviceLiquidation'
import Statement from './Statement'
import SettingIcons from '@/icons/SettingIcons'
import { Shield, FileCheck } from 'lucide-react'
import { TFunction } from 'i18next'
import ServicesWithSLA from '../SLA/ServicesWithSLA'

export const tabs = (t: TFunction) => [
    {
        label: t('service-all'),
        value: '',
        startIcon: <ServiceActiveIcons />,
        component: <AllService />,
    },
    {
        label: t('service-waiting-confirm'),
        value: 'waiting-confirm',
        startIcon: <ServiceWaitingConfirmIcons />,
        component: <WaitingConfirm />,
    },
    {
        label: t('service-poc'),
        value: 'service-poc',
        startIcon: <ServiceTrialIcons />,
        component: <POC />,
    },
    {
        label: t('services:services-with-sla-tab'),
        value: 'service-sla',
        startIcon: <Shield className="w-4 h-4" />,
        component: <ServicesWithSLA />,
    },
    {
        label: t('service-device-liquidation'),
        value: 'device-liquidation',
        startIcon: <SettingIcons />,
        component: <DeviceLiquidation />,
    },
    {
        label: t('services:service-statement-tab'),
        value: 'statement',
        startIcon: <FileCheck className="w-4 h-4" />,
        component: <Statement />,
    },
]
